<template>
  <CCard class="question__card">
    <CCardHeader>{{ exam.title }}</CCardHeader>
    <CCardBody class="d-flex flex-column align-items-start h-100">
      <div v-if="imagePreview" class="image-preview">
        <div class="bg-shadow"></div>
        <img :src="imagePreview" class="" @click="imagePreview = null"/>
      </div>
      <div
          v-if="exam.solutionText || exam.solutionFileUrls.length"
          class="w-100"
      >
        <h5 class="wrapper w-100">پاسخنامه:</h5>
        <div class="w-100">
          <h6>توضیحات</h6>
          <div class="desc w-100 text-sm">{{ exam.solutionText }}</div>

          <h6 class="mt-3">دانلود فایل/فایل‌ها</h6>
          <div
              v-for="(file, index) in exam.solutionFileUrls"
              :key="index"
              class="download-file mb-3 ml-2"
          >
            <a :href="file" download="" target="_blank">
              <CIcon name="cil-file"/>
            </a>
          </div>
        </div>
      </div>

      <div class="mt-4 w-100">
        <h5 class="wrapper w-100">سوالات:</h5>
        <div
            v-for="(question, index) in questions"
            :key="question.id"
            class="question__wrapper"
        >
          <div class="my-3">
            <span class="bold">{{ index + 1 }}. سوال:</span>{{ question.text }} ({{ question.level }})
          </div>
          <div v-if="filterQuestionVideos.length" class="flex-fill">
            <video class="media-video__wrapper" controls>
              <source v-if="question.fileUrl" :src="question.fileUrl"/>
            </video>
          </div>
          <div v-if="filterQuestionAudios.length" class="flex-fill">
            <audio class="media-audio__wrapper" controls>
              <source v-if="question.fileUrl" :src="question.fileUrl"/>
            </audio>
          </div>
          <div
              v-if="filterQuestionImages.length"
              class="media-image__wrapper flex-fill mx-2"
          >
            <img
                v-if="question.fileUrl"
                :src="question.fileUrl"
                alt=""
                @click="imagePreview = question.fileUrl"
            />
          </div>

          <div v-else-if="question.fileUrl" class="download-file ml-3 my-2">
            <a :href="question.fileUrl" download="" target="_blank">
              <CIcon name="cil-file"/>
            </a>
          </div>
          <!--         MULTI_CHOICES questions-->

          <div v-if="question.type === 'MULTI_CHOICES'" class="my-3">
            <div
                v-for="(choice, index) in question.choices"
                :key="index"
                class="my-2"
            >
              <div v-if="choice !== ''">
                {{ index + 1 }}.
                <img
                    v-if="choice.includes('http')"
                    :src="choice"
                    class="choice-image ml-2"
                    @click="imagePreview = choice"
                />
                <span v-else class="ml-2"> {{ choice }}</span>
                <span v-if="index === question.correctAnswerIndex" class="bold success">(پاسخ صحیح)</span>

              </div>
            </div>
          </div>
          <div v-for="answer in answers" :key="answer.id">
            <div
                v-if="
                answer.question.id === question.id &&
                question.type === 'MULTI_CHOICES'
              "
                class="my-3"
            >
              <span class="bold ml-2 primary">پاسخ شما:</span>
              گزینه ی {{ Number(answer.selectedIndex) + 1 }}
            </div>

            <!--           TEXT questions-->
            <div
                v-if="
                answer.question.id === question.id && question.type === 'TEXT'
              "
            >
              <div class="my-3">
                <span class="bold">پاسخ شما:</span>
                {{ answer.text }}
              </div>
              <div v-if="filterAnswerVideos.length" class="flex-fill">
                <video class="media-video__wrapper" controls>
                  <source v-if="answer.fileUrl" :src="answer.fileUrl"/>
                </video>
              </div>
              <div v-if="filterAnswerAudios.length" class="flex-fill">
                <audio class="media-audio__wrapper" controls>
                  <source v-if="answer.fileUrl" :src="answer.fileUrl"/>
                </audio>
              </div>
              <div
                  v-if="filterAnswerImages.length"
                  class="media-image__wrapper flex-fill mx-2"
              >
                <img
                    v-if="answer.fileUrl"
                    :src="answer.fileUrl"
                    alt=""
                    @click="imagePreview = answer.fileUrl"
                />
              </div>

              <div v-else-if="answer.fileUrl" class="download-file ml-3 my-2">
                <a :href="answer.fileUrl" download="" target="_blank">
                  <CIcon name="cil-file"/>
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>
    </CCardBody>
  </CCard>
</template>

<script>
import axios from "@/plugins/axios";

export default {
  props: {
    exam: {
      type: Object,
    },
  },
  data() {
    return {
      answers: [],
      questions: [],
      loading: false,
      imagePreview: null,
    };
  },
  computed: {
    filterAnswerImages() {
      return this.answers.filter((item) =>
          item.fileUrl
              ? item.fileUrl.toLowerCase().includes("jpg")
              : "" || item.fileUrl
                  ? item.fileUrl.toLowerCase().includes("png")
                  : "" || item.fileUrl
                      ? item.fileUrl.toLowerCase().includes("jpeg")
                      : "" || item.fileUrl
                          ? item.fileUrl.toLowerCase().includes("bmp")
                          : "" || item.fileUrl
                              ? item.fileUrl.toLowerCase().includes("tiff")
                              : "" || item.fileUrl
                                  ? item.fileUrl.toLowerCase().includes("gif")
                                  : "" || item.fileUrl
                                      ? item.fileUrl.toLowerCase().includes("svg")
                                      : ""
      );
    },
    filterAnswerVideos() {
      return this.answers.filter((item) =>
          item.fileUrl
              ? item.fileUrl.toLowerCase().includes("mp4")
              : "" || item.fileUrl
                  ? item.fileUrl.toLowerCase().includes("mkv")
                  : "" || item.fileUrl
                      ? item.fileUrl.toLowerCase().includes("avi")
                      : "" || item.fileUrl
                          ? item.fileUrl.toLowerCase().includes("mov")
                          : "" || item.fileUrl
                              ? item.fileUrl.toLowerCase().includes("webm")
                              : "" || item.fileUrl
                                  ? item.fileUrl.toLowerCase().includes("flv")
                                  : ""
      );
    },
    filterAnswerAudios() {
      return this.answers.filter((item) =>
          item.fileUrl
              ? item.fileUrl.toLowerCase().includes("mp3")
              : "" || item.fileUrl
                  ? item.fileUrl.toLowerCase().includes("ogg")
                  : "" || item.fileUrl
                      ? item.fileUrl.toLowerCase().includes("m4a")
                      : "" || item.fileUrl
                          ? item.fileUrl.toLowerCase().includes("aac")
                          : "" || item.fileUrl
                              ? item.fileUrl.toLowerCase().includes("wav")
                              : ""
      );
    },
    filterQuestionImages() {
      return this.questions.filter((item) =>
          item.fileUrl
              ? item.fileUrl.toLowerCase().includes("jpg")
              : "" || item.fileUrl
                  ? item.fileUrl.toLowerCase().includes("png")
                  : "" || item.fileUrl
                      ? item.fileUrl.toLowerCase().includes("jpeg")
                      : "" || item.fileUrl
                          ? item.fileUrl.toLowerCase().includes("bmp")
                          : "" || item.fileUrl
                              ? item.fileUrl.toLowerCase().includes("tiff")
                              : "" || item.fileUrl
                                  ? item.fileUrl.toLowerCase().includes("gif")
                                  : "" || item.fileUrl
                                      ? item.fileUrl.toLowerCase().includes("svg")
                                      : ""
      );
    },
    filterQuestionVideos() {
      return this.questions.filter((item) =>
          item.fileUrl
              ? item.fileUrl.toLowerCase().includes("mp4")
              : "" || item.fileUrl
                  ? item.fileUrl.toLowerCase().includes("mkv")
                  : "" || item.fileUrl
                      ? item.fileUrl.toLowerCase().includes("avi")
                      : "" || item.fileUrl
                          ? item.fileUrl.toLowerCase().includes("mov")
                          : "" || item.fileUrl
                              ? item.fileUrl.toLowerCase().includes("webm")
                              : "" || item.fileUrl
                                  ? item.fileUrl.toLowerCase().includes("flv")
                                  : ""
      );
    },
    filterQuestionAudios() {
      return this.questions.filter((item) =>
          item.fileUrl
              ? item.fileUrl.toLowerCase().includes("mp3")
              : "" || item.fileUrl
                  ? item.fileUrl.toLowerCase().includes("ogg")
                  : "" || item.fileUrl
                      ? item.fileUrl.toLowerCase().includes("m4a")
                      : "" || item.fileUrl
                          ? item.fileUrl.toLowerCase().includes("aac")
                          : "" || item.fileUrl
                              ? item.fileUrl.toLowerCase().includes("wav")
                              : ""
      );
    },
  },
  mounted() {
    this.getAnswer();
    this.getQuestion();
  },
  methods: {
    async getQuestion() {
      try {
        this.loading = true;
        const {id: examId} = this.$route.params;
        const {data} = await axios.get(`/exam/${examId}/question`);
        this.questions = data;
      } catch (error) {
        console.log("errrror:", error);
      } finally {
        this.loading = false;
      }
    },
    async getAnswer(routeName) {
      try {
        this.loading = true;
        const {id: examId} = this.$route.params;
        const {data} = await axios.get(`/exam/${examId}/answer`, {
          params: {studentId: this.$userId},
        });
        this.answers = data;

        routeName = `${this.exam.title}`;
        this.$emit("go-to", routeName);
      } catch (error) {
        console.log("errrror:", error);
      } finally {
        this.loading = false;
      }
    },
  },
};
</script>
<style lang="scss" scoped>
.download-file {
  display: inline-block;
  width: 65px;
  height: 65px;
  border: 1px solid #9da5b1;
  color: #9da5b1;
  text-align: center;
  line-height: 65px;
  cursor: pointer;
  border-radius: 8px;

  .c-icon {
    width: 2rem;
    height: 2rem;
  }
}

.desc {
  word-wrap: break-word;
  white-space: pre-line;
  font-size: 14px;
  line-height: 1.5;
}

.wrapper {
  background-color: #ebedef;
  padding: 12px;
  border-radius: 8px;
}

.media-image__wrapper {
  position: relative;

  img {
    width: 100%;
    height: auto;
    object-fit: cover;
    border-radius: 8px;
    cursor: pointer;
    @media (max-width: 768px) {
      min-width: 100%;
      max-width: 100%;
    }
  }
}

.media-video__wrapper {
  position: relative;
  width: 100%;
  height: auto;
  border-radius: 8px;
}

.media-audio__wrapper {
  position: relative;
}

.question__wrapper {
  border-bottom: 1px solid #d8dbe0;
  padding: 8px 0;
}

.choice-image {
  height: 150px;
  width: auto;
  max-width: calc(100% - 50px);
  object-fit: contain;
  border-radius: 8px;
  cursor: pointer;
}

.image-preview {
  position: fixed;
  top: 0;
  bottom: 0;
  right: 0;
  left: 0;
  z-index: 2000;
  display: flex;
  justify-content: center;
  width: 100vw;
  max-height: 100vh;

  .bg-shadow {
    width: 100%;
    height: 100%;
    position: absolute;
    top: 0;
    bottom: 0;
    right: 0;
    left: 0;
    background: #000000cc;
  }

  img {
    width: 90%;
    height: auto;
    object-fit: contain;
    z-index: 3000;
  }
}
</style>